export default __webpack_public_path__ + "static/media/empty-state.8125c99d.svg";